// extracted by mini-css-extract-plugin
export default {"stat-card":"BankTransferUpdateStatus_stat-card__q+0Pb","stats-container":"BankTransferUpdateStatus_stats-container__gLzLu"};